import { Box, Text, Select, Textarea } from "@mantine/core";
import { Alert } from "@xplatform/design-system";
import { IconInfoCircle } from "@tabler/icons-react";
import { FlowType } from "@models/doctype";
import {
    translateFlowType,
    flowTypeDescription,
} from "@utils/flowTypeTranslations";
import { useTranslation } from "@hooks/useTranslation";
import "./FlowTypeSelector.scss";

interface FlowTypeSelectorProps {
    flowType: string;
    flowDescription: string;
    onFlowTypeChange: (flowType: string) => void;
    onDescriptionChange: (description: string) => void;
}

export const FlowTypeSelector = ({
    flowType,
    flowDescription,
    onFlowTypeChange,
    onDescriptionChange,
}: FlowTypeSelectorProps) => {
    const { t } = useTranslation();

    const flowTypeData = Object.values(FlowType).map((type) => ({
        value: type,
        label: translateFlowType(type, t),
    }));

    const description = flowType ? flowTypeDescription(flowType, t) : "";

    return (
        <Box className="flow-type-selector">
            <Text fw={600} size="lg" className="flow-type-selector__title">
                Select Flow Type
            </Text>
            <Select
                label={t("admin.table.columns.type")}
                value={flowType || null}
                onChange={(value) => onFlowTypeChange(value || "")}
                data={flowTypeData}
                className="flow-type-selector__control"
                comboboxProps={{ withinPortal: false }}
            />

            {description && (
                <Alert
                    icon={<IconInfoCircle size={16} />}
                    color="blue"
                    variant="light"
                    className="flow-type-selector__type-description"
                >
                    {description}
                </Alert>
            )}

            <Textarea
                label={t("admin.table.columns.description")}
                value={flowDescription}
                onChange={(e) => onDescriptionChange(e.currentTarget.value)}
                rows={2}
                placeholder={t("admin.flowConfigs.create.descriptionPlaceholder")}
                className="flow-type-selector__description"
            />
        </Box>
    );
};
